import React from "react";
import SocialLinks from "./social";
import "./footer.css";
import whatsappIcon from "../images/Digital_Glyph_Green.png";
import instagramIcon from "../images/Instagram_Glyph_Gradient.png";
import messengerIcon from "../images/Facebook_Logo_Primary.png";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">

                {/* Brand Section */}
                <div className="footer-brand">
                    <h2 className="footer-title">Small Temples</h2>
                    <p className="footer-tagline">
                        Customised small temples crafted with devotion.
                    </p>
                    <p className="footer-tagline">
                        my.small.temples@gmail.com
                    </p>
                </div>

                {/* Contact Section */}
                <div className="footer-contact">
                    <p>
                        <span role="img" aria-label="phone"> 📞 </span> <a href="tel:+61447829021">0447 829 021</a>
                    </p>
                    <p>
                        <span role="img" aria-label="whatsapp"> 💬 </span> <a href="https://wa.me/61447829021" target="_blank" rel="noopener noreferrer">
                            Chat on WhatsApp
                        </a>
                    </p>

                </div>

                {/* Social Section */}
                <div className="footer-social">
                    <SocialLinks
                        links={[
                            {
                                name: "WhatsApp",
                                url: "https://wa.me/61447829021",
                                icon: whatsappIcon,
                            },
                            {
                                name: "Instagram",
                                url: "https://instagram.com/small_temples_",
                                icon: instagramIcon,
                            },
                            {
                                name: "Messenger",
                                url: "https://m.me/204660398934934",
                                icon: messengerIcon,
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Small Temples. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;